import React from "react";

import TableServerSort from "components/Table/TableServerSort";
import { DEFAULT_PER_PAGE_MAX } from "const";

const TableSection = ({
    tableRef,
    dataList,
    dataLoading,
    filteredTableColumns,
    dataCount,
    dataPerPage,
    dataPage,
    getNumberList,
    getRowKey,
    trunk_id,
    currentDisplay,
    setNumberPageState,
    perPageLSKey,
    onChangePerPage,
    setSort,
    isMobile,
    groupActionCell,
    isselected,
    keepSelectedItems,
    updateSelectedList,
    columnSelectorLSKey,
    additionalColumnUpdate
}) => {
    return (
        <TableServerSort
            shouldUpdateScroll={false}
            ref={tableRef}
            data={dataList}
            height="50%"
            loading={dataLoading}
            columns={filteredTableColumns}
            originalColumns={filteredTableColumns}
            additionalColumnUpdate={additionalColumnUpdate}
            rowClassName={(rowData) => {
                if (rowData) {
                    const { active } = rowData;

                    if (Object.keys(rowData).includes("active") && !active) {
                        return "table-row-prefix--disabled";
                    }
                }
                return undefined;
            }}
            columnSelectorLSKey={columnSelectorLSKey}
            count={dataCount}
            per_page={dataPerPage}
            perPageLSKey={perPageLSKey}
            perPageMaximum={DEFAULT_PER_PAGE_MAX}
            page={dataPage}
            getItems={getNumberList}
            row_key={getRowKey()}
            disabled={!trunk_id}
            ispagination={currentDisplay !== "groups"}
            onChangePage={(value) => {
                setNumberPageState(value);
            }}
            onSort={(column, type) => setSort({ column, type })}
            onChangePerPage={onChangePerPage}
            isMobile={isMobile}
            {...(currentDisplay === "groups" ? {
                ActionCell: groupActionCell
            } : {
                isselected,
                isSelectedAll: isselected,
                useSelectedData: keepSelectedItems,
                setSelected: updateSelectedList
            })}
        />
    );
};

export default TableSection;
